/* global BigInt */
import { ethers } from 'ethers';


// Generate random int, inclusive of min/max, using same method as Solidity code
function randomIntFromInterval(randomSeed, min, max) {
    if (max <= min) {
        return min;
    }
    const abiCoder = new ethers.AbiCoder();
    const abiCodedSeed = abiCoder.encode(["uint"], [randomSeed]);
    const hash = ethers.keccak256(abiCodedSeed);
    const seed = BigInt(hash);

    const value = seed % BigInt(max - min) + BigInt(min);
    //   var value =  Math.floor(Math.random() * (max - min + 1) + min);
    return Number(value);
}

function generateRandomStripesDataUri() {
    const randomSeed = Math.trunc(Math.random() * 5_000_000);
    // const randomZoom = randomIntFromInterval(randomSeed, 0, 100);
    // const svgString = encodeURIComponent(generateDynaStripes(randomSeed, randomZoom, null, 0, 180, 25, 250, 0, 255, 25, 250));

    const svgString = encodeURIComponent(generateDynaStripes(randomSeed, 0, null, 0, 0, 25, 250, 25, 250));
    return `url("data:image/svg+xml,${svgString}")`;
}

function generateDynaStripes(randomSeed, zoom, tintColour, rotationDegrees, rotationVariation, widthMin, widthMax, speedMin, speedMax) {
    // console.log("Generating dynastripes: " + randomSeed + " " + zoom + " " + rotationDegrees + " "  + rotationVariation + " " + widthMin + " " + widthMax + " " + speedMin + " " + speedMax);

    if (tintColour === null) {
        tintColour = { r: 0, g: 0, b: 0, a: 0 };
    }

    const viewBoxClipRect = getViewBoxClipRect(zoom);
    const viewBox = viewBoxClipRect[0];
    const clipRect = viewBoxClipRect[1];
    const rendering = rotationVariation === 0 ? 'crispEdges' : 'auto';
    const defs = "<defs><clipPath id='masterClip'><rect " + clipRect + "/></clipPath></defs>";
    const rects = getRects(randomSeed, tintColour, rotationDegrees, rotationVariation, widthMin, widthMax, speedMin, speedMax);

    return "<svg xmlns='http://www.w3.org/2000/svg' viewBox='" + viewBox + "' shape-rendering='" + rendering + "'>" + defs + "<g clip-path='url(#masterClip)'>" + rects + "</g></svg>";
}

function getViewBoxClipRect(zoom) {
    zoom = zoom * 20;
    const widthHeight = 1000 + zoom;
    let viewBox;
    let clipRect;
    let offset = (zoom - 1000) / 2;
    if (zoom > 1000) {
        viewBox = "-" + offset + " -" + offset + " " + widthHeight + " " + widthHeight;
        clipRect = "x='-" + offset + "' y='-" + offset + "' width='" + widthHeight + "' height='" + widthHeight + "'";

    } else {
        offset = (zoom === 1000 ? 0 : (1000 - zoom) / 2);
        viewBox = "" + offset + " " + offset + " " + widthHeight + " " + widthHeight;
        clipRect = "x='" + offset + "' y='" + offset + "' width='" + widthHeight + "' height='" + widthHeight + "'";
    }

    return [viewBox, clipRect];
}

function getRects(randomSeed, tintColour, rotationDegrees, rotationRange, widthMin, widthMax, speedMin, speedMax) {
    let xPos = 0;
    let rects = "";

    while ((2000 - xPos) > 0) {

        let stripeWidth = randomIntFromInterval(randomSeed, widthMin, widthMax) * 2;

        if (stripeWidth > 2000 - xPos) {
            stripeWidth = 2000 - xPos;
        } else if ((2000 - xPos) - stripeWidth < widthMin) {
            stripeWidth += (2000 - xPos) - stripeWidth;
        }

        const rotation = getRotation(randomSeed + 1, rotationDegrees, rotationRange);
        const speed = randomIntFromInterval(randomSeed + 2, speedMin, speedMax) * 20;
        const firstColour = getColour(randomSeed + 3, tintColour);
        const secondColour = getColour(randomSeed + 13, tintColour);
        const colours = firstColour + ";" + secondColour + ";" + firstColour;

        let currentRect = "<rect x='" + xPos + "' y='0' width='" + stripeWidth + "' height='2000' fill='" + firstColour + "' opacity='0.8' transform='rotate(" + rotation + " 1000 1000)'>";
        currentRect += "<animate begin= '0s' dur='" + speed + "ms' attributeName='fill' values='" + colours + ";' fill='freeze' repeatCount='indefinite'/>";
        currentRect += "</rect>";

        rects += currentRect;

        xPos += stripeWidth;
        randomSeed += 100;
    }

    return rects;
}

function getRotation(randomSeed, rotationDegrees, rotationRange) {
    const randomDegrees = randomIntFromInterval(randomSeed, 0, rotationRange);
    let rotation;

    if (randomDegrees === 0) {
        rotation = rotationDegrees;
    } else if (randomDegrees < rotationRange) {
        rotation = 360 + rotationDegrees - randomDegrees + rotationRange / 2;
    } else {
        rotation = rotationDegrees + randomDegrees - rotationRange / 2;
    }

    if (rotation > 360) {
        rotation = rotation - 360;
    }

    return rotation;
}

// Mirrors ColourWork.safeTint: integer maths, floor division, alpha 0-255.
// Note the offset is floored *before* being applied, and applied away from the
// component in the c > t case -- that is not the same as flooring the blend.
function safeTint(colourComponent, tintComponent, alpha) {
    if (alpha === 0) {
        return colourComponent;
    }

    if (colourComponent <= tintComponent) {
        return colourComponent + Math.floor(((tintComponent - colourComponent) * alpha) / 255);
    }
    return colourComponent - Math.floor(((colourComponent - tintComponent) * alpha) / 255);
}

function getColour(randomSeed, tintColour) {
    // tintColour.a is a 0-1 fraction here; the contract stores 0-255, and that
    // rounded value is what gets minted, so tint against the same number.
    const alpha = Math.round(tintColour.a * 255);

    // Seed offsets must match DynaStripes.getColour: red +0, green +1, blue +2.
    const red = safeTint(randomIntFromInterval(randomSeed, 0, 255), tintColour.r, alpha);
    const green = safeTint(randomIntFromInterval(randomSeed + 1, 0, 255), tintColour.g, alpha);
    const blue = safeTint(randomIntFromInterval(randomSeed + 2, 0, 255), tintColour.b, alpha);

    return "rgb(" + red + ", " + green + ", " + blue + ")";
}

export default generateDynaStripes;
export { generateRandomStripesDataUri, generateDynaStripes };